<template>
  <Modal :title="$t('modals.select_stock_symbol_modal.title')">
    <SelectStockSymbol v-model="selectedStockSymbol" />

    <template #buttons>
      <BaseButton
        :label="$t('global.cancel')"
        new-design
        @click.prevent="$modals.close('SelectStockSymbolModal')"
      />
      <BaseButton
        color="primary"
        :label="$t('global.apply')"
        new-design
        @click="select"
      />
    </template>
  </Modal>
</template>

<script>
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";
import SelectStockSymbol from "shared/components/selectors/SelectStockSymbol.vue";

export default {
  name: "SelectStockSymbolModal",
  components: {
    Modal,
    SelectStockSymbol,
    BaseButton,
  },
  props: {
    stockSymbol: {
      type: String,
      required: true,
    },
  },
  emits: ["select"],
  data() {
    return {
      selectedStockSymbol: this.stockSymbol,
    };
  },
  methods: {
    select() {
      this.$emit("select", this.selectedStockSymbol);
      this.$modals.close("SelectStockSymbolModal");
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  :deep(input) {
    padding: 1em;
  }
}

:deep(.q-select) {
  background-color: #fff;
}
</style>
